module.exports = __webpack_public_path__ + "Flag-232.fc2f1da58dbf5e6be6cbe4677b01158c.svg";